/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VmMenu } from '@vime/core';
import { define } from '../lib';
define('vm-menu', VmMenu);
export default Vue.extend({
    props: {
        active: {},
        identifier: {},
        controller: {},
        slideInDirection: {},
    },
    methods: {
        focusMenu: method('focusMenu'),
        blurMenu: method('blurMenu'),
        getActiveMenuItem: method('getActiveMenuItem'),
        setActiveMenuItem: method('setActiveMenuItem'),
        calculateHeight: method('calculateHeight'),
    },
    render: render('vm-menu', ['vmOpen', 'vmClose', 'vmFocus', 'vmBlur', 'vmActiveSubmenuChange', 'vmActiveMenuItemChange', 'vmMenuHeightChange']),
});
//# sourceMappingURL=Menu.js.map